import { useState, useEffect } from "react";

function useWindowFocus() {
  const [hasFocus, setFocus] = useState<boolean>();

  useEffect(() => {
    const onFocus = () => setFocus(true);
    const onBlur = () => setFocus(false);
    window.onfocus = onFocus;
    window.onblur = onBlur;
  }, []);

  return hasFocus;
}

export default useWindowFocus;
